import { _request, APIBaseResponse,APIMethod } from '../';

const GLOBALROLES_PATH_PREFIX = '/globalroles';

type APIGlobalRoleGetListResponse = APIBaseResponse<
    Array<{
        id: string;
        name: string;
        description: string;
    }>
>;

export const APIGlobalRoleGetList: APIMethod<void, APIGlobalRoleGetListResponse> = () => (
    _request('GET', GLOBALROLES_PATH_PREFIX)
);
